import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { getVersionClear } from './Localstorage/localstorage';

getVersionClear();

// App-wide WhatsApp-style theme: always use Tailwind `dark:` tokens + `wa` palette.
document.documentElement.classList.add("dark");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Removed React.StrictMode to avoid double-invoking renders and effects in development
  <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
